export default __webpack_public_path__ + "static/2-25741aaa77f49012e173f4f6dbd6cd37.png";